import { render, staticRenderFns } from "./default.vue?vue&type=template&id=61724799&scoped=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=61724799&prod&scoped=true&lang=css"
import style1 from "./default.vue?vue&type=style&index=1&id=61724799&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61724799",
  null
  
)

export default component.exports